import { createSelector } from "@reduxjs/toolkit";

export const getInitalValues = (profile: any) => {
    return {
        ...profile,
        id: profile.userId,  // Set id to userId to match Flutter payload format
        motherTongue: profile.religion,
        monthlyIncome: profile.salaryDetails,
        instagramUrl: profile.instagramUrl || "",
        linkedinUrl: profile.linkedinUrl || "",
    }
}

export const ProfileSelector = createSelector(
    (state: any) => state.staticData,
    (state: any) => state.auth.user,
    (staticData: any, user) => {
        return {
            ...staticData,
            nativeStates: staticData.states,
            nativeDistricts: staticData.districts,
            profile: user.profile
        }
    }
);